<div class="w-100 my-2" *ngIf="columnas.length && displayedColumns.length">
    <div class="row mx-0 justify-content-md-between">
        <div class="col-md-auto">
            <mat-paginator [pageSize]="config.filasPagina" class="pg" [pageSizeOptions]="config.catFilasPag" showFirstLastButtons></mat-paginator>
        </div>
        <div class="col-md-auto">
            <mat-form-field floatLabel="always">
                <mat-label>Filtro</mat-label>
                <input matInput (keyup)="applyFilter($event)" #input>
            </mat-form-field>
        </div>
       
    </div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="apellidoPaterno" 
        matSortDisableClear matSortDirection="desc" (matSortChange)="paginator.pageIndex = 0;">

        <ng-container *ngFor="let cla of columnas" [matColumnDef]="cla.id">

            
            
            <ng-container [ngSwitch]="cla.id">
                <ng-container *ngSwitchCase="'checkbox'">
                    <th class="text-center ancho-40" mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="seleccion.hasValue() && isAllSelected"
                            [indeterminate]="seleccion.hasValue() && !isAllSelected">
                        </mat-checkbox>
                    </th>
                    <td class="ancho-40 text-left" mat-cell *matCellDef="let fila">
                        <!-- <mat-checkbox 
                            (click)="$event.stopPropagation()"
                            [color]="config.colorChecks"
                            (change)="$event ? seleccion.toggle(fila) : null"
                            [checked]="seleccion.isSelected(fila)">
                        </mat-checkbox> -->
                        <mat-slide-toggle
                            (click)="$event.stopPropagation()"
                            [color]="config.colorChecks"
                            (change)="$event ? seleccion.toggle(fila) : null"
                            [checked]="seleccion.isSelected(fila)">
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <ng-container *ngSwitchCase="'apellidoPaterno'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cla.titulo}}</th>
                    <td class="text-left" mat-cell *matCellDef="let fila">
                        {{fila.nombre + ' '+ fila.apellidoPaterno + ' '+ fila.apellidoMaterno}}
                    </td>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cla.titulo}}</th>
                    <td class="text-left" mat-cell *matCellDef="let fila"> {{fila[cla.id]}} </td>
                </ng-container>
            </ng-container>

        </ng-container>

        <tr class="mat-row" *matNoDataRow>
            <td *ngIf="input.value !== ''" class="mat-cell" colspan="4">No se encontro resultados de : "{{input.value}}"</td>
        </tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


</div>